import { PostMessageProxyPromise } from "@ciaopeople/cp-shatsu/RemoteService";
import { SNHUBLogicPublicData } from "../SNHUBLogicPublicData.js";

export class SNHUBLogicPublicDataRemoteImpl implements SNHUBLogicPublicData {


    constructor(private proxy: PostMessageProxyPromise) {

    }

    public getSNUTokenAnyways(): Promise<string> {
        return this.proxy.invoke("getSNUTokenAnyways");
    }

}